class CustomBundleForm extends HTMLElement {
  constructor() {
    super();
    this.quanityBoxOpeners = this.querySelectorAll(".flavor_add-btn");
    this.quantityButtons = this.querySelectorAll(".flavor_qty-button");
    this.atcButton = this.querySelector(".product-form__submit");
    
    // Detect cart type - check for old cart drawer first (plain div with ID)
    this.isOldCart = document.querySelector('#cart-drawer') !== null;
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    
    this.mainProductVaraintId = this.dataset.variantid;
    this.maxNumber = this.dataset.maxproduct;
    this.quantityCounter = 0;
    this.variantInfoOpeners = this.querySelectorAll(".variant-info-opener");
    this.setupEventListeners();
  }
  setupEventListeners(){
    this.quanityBoxOpeners.forEach((el) => {
      el.addEventListener('click',this.openQuantityBox.bind(this));
    });
    this.quantityButtons.forEach((el) => {
      const that = this;
      el.addEventListener('click',(evt)=>{
        that.onQuantityChange(evt,el);
      });
    });
    this.atcButton.addEventListener("click",this.addToCart.bind(this));
    this.variantInfoOpeners.forEach((el) => {
          const that = this;
          el.addEventListener('click',(evt)=>{
              that.openVariantInfo(evt,el);
          });
      });
  }
   openVariantInfo(evt,el){
       const parentElement = el.closest(".bundle-image-with-quantity-wrapper");
       const variantID = el.dataset.vid;
       this.querySelectorAll(".custom-variant-info").forEach((el) => {
        if(el.dataset.vid == variantID){
            el.classList.remove("hidden");
        }else{
            el.classList.add("hidden");
        }
       });
       console.log(parentElement,"parentElementparentElementparentElementparentElement");
       this.querySelectorAll(".bundle-image-with-quantity-wrapper").forEach((el) => {
            if(el == parentElement){
                el.classList.add("selected-info");
            }else{
                el.classList.remove("selected-info");
            }
       });
       
    }
  getSelleingPlanId(){
      const subscribeOption = this.querySelector(".custom-sub-selection:checked");
      if(subscribeOption){
          if(subscribeOption.value == 'subscribe'){
              return this.querySelector(`.custom-selling-plan`).value;
          }
      }
      return 0;
  }
  addToCart(evt){
    evt.preventDefault();
    const bundleId = new Date().getTime();
    let items = [];
    let allproperties = [];
    let bundleItems = [];
    let product_main_id = Number(this.mainProductVaraintId);
    //const sellingPlanId = this.getSelleingPlanId();
     const quantity = Array.from(this.querySelectorAll(".custom-bundle-item-qty")).reduce((sum, el) => sum + Number(el.value), 0);
     const currentProduct = this.getThersholdbaseProduct(quantity);
     const currentOffertProducts = this.getThersholdbaseOffertProduct(quantity);
    if(quantity > 1){
      product_main_id = currentProduct.variants[0].id;
      if(currentOffertProducts && currentOffertProducts.length > 0){
        for(let i in currentOffertProducts){
          let productTitle = currentOffertProducts[i].title;
          if(currentOffertProducts[i].vtitle.indexOf("Default") > -1){
          }else{
            productTitle = `${productTitle}:${currentOffertProducts[i].vtitle}`;
          }
          allproperties.push(productTitle);
          bundleItems.push({
            "_childVariantId":currentOffertProducts[i].vid,
            "_baseQty":1,
            "_isMainProduct":0,
            "_isOffertAddon":1
          });
        }
      }
    }else{
      if(window.offeretProducts && window.offeretProducts.length > 0){
        for(let i in window.offeretProducts){
          let productTitle = window.offeretProducts[i].title;
          if(window.offeretProducts[i].vtitle.indexOf("Default") > -1){
          }else{
            productTitle = `${productTitle}:${window.offeretProducts[i].vtitle}`;
          }
          allproperties.push(productTitle);
          bundleItems.push({
            "_childVariantId":window.offeretProducts[i].vid,
            "_baseQty":1,
            "_isMainProduct":0,
            "_isOffertAddon":1
          });
        }
      }
    }
    
    this.querySelectorAll(".custom-bundle-item-qty").forEach((el) => {
      const quanity = Number(el.value);
      if(quanity > 0){
        allproperties.push(el.dataset.vtitle);
        bundleItems.push({
          "_childVariantId":el.dataset.id,
          "_baseQty": quanity,
          "_isMainProduct": 0
        });
      }
    });
     
      items.push({
        id: product_main_id,
        quantity: 1,
        properties:{
          "_customBundleId":bundleId,
          "_isMainProduct":1,
          "Contenu":allproperties.join("|"),
          "childVariants":bundleItems
        }
      });
     
    
    this.atcButton.classList.add('loading');
    this.atcButton.querySelector('.loading__spinner').classList.remove('hidden');
    const _that = this;
    // Build formData based on cart type
    const formData = {
      items:items
    };
    
    // Only add sections if it's the new cart with getSectionsToRender method
    if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
      formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
      formData.sections_url = window.location.pathname;
    } else if (this.isOldCart) {
      // For old cart, add the old-cart-drawer section
      formData.sections = 'old-cart-drawer,cart-icon-bubble';
      formData.sections_url = window.location.pathname;
    }
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then((response) => {
      if (response.status) {
        if (!this.cart && !this.isOldCart) {
          window.location = window.routes.cart_url;
          return;
        }
      }
      
      // Handle old cart drawer
      if (this.isOldCart) {
        // Refresh the old cart drawer with response data
        if (typeof window.refreshCart === 'function') {
          window.refreshCart(response);
          
        }
        // Dispatch custom event to open the old cart
        /*document.dispatchEvent(new CustomEvent('cart:add', { 
          detail: { items: response.items }
        }));*/
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('cart:open'));
        }, 100);
        return;
      }
      
      // Handle new cart (cart-notification or cart-drawer custom element)
      const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-form',
        productVariantId: product_main_id,
        cartData: response,
      }).then(() => {
        CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
      });
      const quickAddModal = this.atcButton.closest('quick-add-modal');
      if (quickAddModal) {
        document.body.addEventListener(
          'modalClosed',
          () => {
            setTimeout(() => {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            });
          },
          { once: true }
        );
        quickAddModal.hide(true);
      } else {
        CartPerformance.measure("add:paint-updated-sections", () => {
          this.cart.renderContents(response);
        });
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      this.resetAllTheData();
      this.atcButton.classList.remove('loading');
      if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      this.atcButton.removeAttribute('aria-disabled');
      this.atcButton.querySelector('.loading__spinner').classList.add('hidden');
      CartPerformance.measureFromEvent("add:user-action", evt);
    });
  }
  resetAllTheData(){
    this.querySelectorAll(".custom-bundle-item-qty").forEach((el) => {
      const quanity = Number(el.value);
        if(quanity >= 1){
          console.log("elele",el);
          const parentElement = el.closest(".flavor2_quantity-container");
          el.value = 1;
          parentElement.querySelector(`.flavor_qty-button[data-type="minus"]`).click();
        }
        
      });
  }
  onQuantityChange(evt,button){
    const buttonType = button.dataset.type;
    const inputElement = button.parentElement.querySelector('.custom-bundle-item-qty');
    const quantityDisplayElement = button.parentElement.querySelector('.flavor_qty-display');
    if(buttonType == 'plus'){
      inputElement.stepUp();
    }else{
      inputElement.stepDown();
      if(inputElement.value <= 0){
        button.parentElement.classList.add("hidden");
        button.parentElement.previousElementSibling.classList.remove("hidden");
      }
    }
    quantityDisplayElement.textContent = inputElement.value;
    this.updateStateAndValue();
    this.updateProgressbarState();
  }
  getThersholdbaseProduct(threshold){
    if(this.dataset.customquanity > 0){
      if(threshold == 10){
        return window.thresholdProduct_10;
      }else if(threshold == 9){
        return window.thresholdProduct_9;
      }else if(threshold == 8){
        return window.thresholdProduct_8;
      }else if(threshold == 7){
        return window.thresholdProduct_7;
      }else if(threshold == 6){
        return window.thresholdProduct_6;
      }else if(threshold == 5){
        return window.thresholdProduct_5;
      }else if(threshold == 4){
        return window.thresholdProduct_4;
      }else if(threshold == 3){
        return window.thresholdProduct_3;
      }else if(threshold == 2){
        return window.thresholdProduct_2;
      }else if(threshold == 1){
        return window.thresholdProduct_1;
      }
    }else{
      if(threshold == this.dataset.thresholdqty4){
        return window.thresholdProduct_4;
      }else if(threshold == this.dataset.thresholdqty3){
        return window.thresholdProduct_3;
      }else if(threshold == this.dataset.thresholdqty2){
        return window.thresholdProduct_2;
      }else{
        return window.thresholdProduct_1;
      }
    }
    
  }
  getThersholdbaseOffertProduct(threshold){
     if(this.dataset.customquanity > 0){
      if(threshold == 10){
        return window.offeretProducts_10;
      }else if(threshold == 9){
        return window.offeretProducts_9;
      }else if(threshold == 8){
        return window.offeretProducts_8;
      }else if(threshold == 7){
        return window.offeretProducts_7;
      }else if(threshold == 6){
        return window.offeretProducts_6;
      }else if(threshold == 5){
        return window.offeretProducts_5;
      }else if(threshold == 4){
        return window.offeretProducts_4;
      }else if(threshold == 3){
        return window.offeretProducts_3;
      }else if(threshold == 2){
        return window.offeretProducts_2;
      }else if(threshold == 1){
        return window.offeretProducts;
      }
     }else{
      if(threshold == this.dataset.thresholdqty4){
        return window.offeretProducts_4;
      }else if(threshold == this.dataset.thresholdqty3){
        return window.offeretProducts_3;
      }else if(threshold == this.dataset.thresholdqty2){
        return window.offeretProducts_2;
      }else{
        return window.offeretProducts;
      }
     }
    
  }
  updateButtonPrice(){
     const quanity = Array.from(this.querySelectorAll(".custom-bundle-item-qty")).reduce((sum, el) => sum + Number(el.value), 0);
     const currentProduct = this.getThersholdbaseProduct(quanity);
    if(currentProduct){
      if(currentProduct.compare_at_price > currentProduct.price){
        this.atcButton.querySelector(".atc-s-price").textContent = Shopify.formatMoney(currentProduct.price);
        if(this.atcButton.querySelector(".atc-o-price")){
          this.atcButton.querySelector(".atc-o-price").textContent = Shopify.formatMoney(currentProduct.compare_at_price);
        }
        
      }else{
         this.atcButton.querySelector(".atc-s-price").textContent = Shopify.formatMoney(currentProduct.price);
         if(this.atcButton.querySelector(".atc-o-price")){
          this.atcButton.querySelector(".atc-o-price").textContent = '';
         }
        
      }
    }
     
  }
  updateStateAndValue(){
    this.querySelectorAll(".custom-bundle-item-qty").forEach((el) => {
      const quanity = Number(el.value);
      const mainElement = el.closest(".bundle-image-with-quantity-wrapper");
      if(quanity > 0){
        mainElement.classList.add("quanity-selected");
      }else{
        mainElement.classList.remove("quanity-selected");
      }
    });
    this.quantityCounter = Array.from(this.querySelectorAll(".custom-bundle-item-qty")).reduce((sum, el) => sum + Number(el.value), 0);
    if(this.quantityCounter == this.maxNumber ){
      this.querySelectorAll(".flavor_card-item").forEach( (el) => {
        if(el.querySelector(".custom-bundle-item-qty")&& el.querySelector(".custom-bundle-item-qty").value > 0){
          if( el.querySelector(`.flavor_qty-button[data-type="plus"]`)){
            el.querySelector(`.flavor_qty-button[data-type="plus"]`).setAttribute("disabled","disabled");
            el.querySelector(`.flavor_qty-button[data-type="minus"]`).removeAttribute("disabled");
          }
          
        }else{
          el.classList.add("opacity-5");
          if(el.querySelector(`.flavor_qty-button[data-type="plus"]`)){
             el.querySelector(`.flavor_qty-button[data-type="plus"]`).setAttribute("disabled","disabled");
            el.querySelector(`.flavor_qty-button[data-type="minus"]`).setAttribute("disabled","disabled");
          }
         if(el.querySelector(".flavor_add-btn")){
          el.querySelector(".flavor_add-btn").setAttribute("disabled","disabled");
         }
          
        }
      });
    }else{
      this.querySelectorAll(".flavor_card-item").forEach( (el) => {
        el.classList.remove("opacity-5");
         if(el.querySelector(`.flavor_qty-button[data-type="plus"]`)){
           el.querySelector(`.flavor_qty-button[data-type="plus"]`).removeAttribute("disabled");
          el.querySelector(`.flavor_qty-button[data-type="minus"]`).removeAttribute("disabled");
         }
       if(el.querySelector(".flavor_add-btn")){
        if(!el.querySelector(".flavor_add-btn").classList.contains('force-disabled')){
          el.querySelector(".flavor_add-btn").removeAttribute("disabled");
        }
        
       }
      });
    }
    if(this.quantityCounter > 0 && (this.quantityCounter <= this.maxNumber)){
      this.atcButton.removeAttribute("disabled");
    } else {
      this.atcButton.setAttribute("disabled","disabled");
    }
    if(this.quantityCounter > 0){
      this.atcButton.querySelector(".custom-text-without-selection").classList.add("hide");
      this.atcButton.querySelector(".default-text").classList.remove("hide");
    }else{
      this.atcButton.querySelector(".custom-text-without-selection").classList.remove("hide");
      this.atcButton.querySelector(".default-text").classList.add("hide");
    }
  }
  updateProgressbarState = () => {
    const quantity = Array.from(this.querySelectorAll(".custom-bundle-item-qty")).reduce((sum, el) => sum + Number(el.value), 0);
    this.querySelector(".quantity-meter-line.filled").style.width = `0px`;
    let customWidth = 0;
    const items = this.querySelectorAll(".quantity-meter-item");
    const lastItem = items[items.length - 1];
    this.querySelectorAll(".quantity-meter-item").forEach((el) => {
      const quanity_threshold = Number(el.dataset.quantity);
      if(quantity >= quanity_threshold){
        const different = quantity - quanity_threshold;
        let extra_offset = 30;
        if(different > 0 && quantity <= lastItem.dataset.quantity){
          extra_offset = 30 +(40*different);
        }
        console.log(different,"different");
        customWidth = this.querySelector(`.quantity-meter-item[data-quantity="${quanity_threshold}"]`).offsetLeft+extra_offset;
        el.querySelector(".quantity-meter-item__circle").classList.add("filled");
        el.querySelector(".quantity-meter-item__circle-inner").classList.add("filled");
        this.querySelector(".quantity-meter-line.filled").style.width = `${customWidth}px`;
      }else{
        el.querySelector(".quantity-meter-item__circle").classList.remove("filled");
        el.querySelector(".quantity-meter-item__circle-inner").classList.remove("filled");
      }
    });
    this.updateButtonPrice();
  }
  
  openQuantityBox(evt){
    const button = evt.target;
    if(button.classList.contains('open-first-tab')){
      document.querySelector("#step-filter-default").checked = true
      document.querySelector("#step-filter-default").dispatchEvent(new Event("change"));
      const vid = button.dataset.vid;
      if(vid){
        const customVariantFormElement =  document.querySelector(`.custom-default-variants-item[data-vid="${vid}"]`);
        if(customVariantFormElement){
          if(customVariantFormElement.querySelector(".flavor_add-btn")){
            customVariantFormElement.querySelector(".flavor_add-btn").dispatchEvent(new Event("click"));
          }
        }
      }
      return;
    }
    button.classList.add("hidden");
    button.parentElement.querySelector(".flavor2_quantity-container").classList.remove("hidden");
    button.parentElement.querySelector(`.flavor2_quantity-container .flavor_qty-button[data-type="plus"]`).click();
  }
  connectedCallback() {}
  disconnectedCallback() {}
}
customElements.define('custom-bundle-form', CustomBundleForm);

// document.addEventListener("DOMContentLoaded", () => {
//   const subscriptionItems = document.querySelectorAll(".one_time_subscription_sdev");

//   subscriptionItems.forEach((item) => {
//     item.addEventListener("click", () => {
//       subscriptionItems.forEach((el) => el.classList.remove("active"));
//       item.classList.add("active");
//     });
//   });
// });

/*

document.addEventListener("DOMContentLoaded", () => {
  const oneTimeBlock = document.querySelector(".one_time_subscription_sdev");
  const subscribeBlock = document.querySelector(".subscription_sdev");
  const planSelector = document.querySelector(".custom-selling-plan");
  const customForm = document.querySelector("custom-bundle-form");

  // set default active and plan on load
  if (subscribeBlock) subscribeBlock.classList.add("active");
  if (planSelector && customForm) {
    const defaultPlanId = planSelector.value;
    customForm.dataset.sellingPlanId = defaultPlanId;
  }

  // handle plan change inside subscription
  if (planSelector) {
    planSelector.addEventListener("change", (e) => {
      const planId = e.target.value;
      if (customForm) customForm.dataset.sellingPlanId = planId;
    });
  }

  // handle click on "Single Purchase"
  if (oneTimeBlock) {
    oneTimeBlock.addEventListener("click", () => {
      oneTimeBlock.classList.add("active");
      if (subscribeBlock) subscribeBlock.classList.remove("active");
      if (customForm) customForm.dataset.sellingPlanId = ""; // remove plan id for one-time
    });
  }

  // handle click on "Subscribe & Save"
  if (subscribeBlock) {
    subscribeBlock.addEventListener("click", () => {
      subscribeBlock.classList.add("active");
      if (oneTimeBlock) oneTimeBlock.classList.remove("active");
      if (planSelector && customForm) {
        const planId = planSelector.value;
        customForm.dataset.sellingPlanId = planId;
      }
    });
  }
});
*/


// document.addEventListener("DOMContentLoaded", () => {
//   const planSelector = document.querySelector(".custom-selling-plan");
//   const customForm = document.querySelector("custom-bundle-form");

//   if (planSelector && customForm) {
//     // Set the default selected plan on load
//     const selectedOption = planSelector.options[planSelector.selectedIndex];
//     const defaultPlanId = selectedOption.value;
//     customForm.dataset.sellingPlanId = defaultPlanId;
//     console.log("Default plan id set:", defaultPlanId);

//     // Update on change
//     planSelector.addEventListener("change", (e) => {
//       const planId = e.target.value;
//       customForm.dataset.sellingPlanId = planId;
//       console.log("Selected plan id:", planId);
//     });
//   }
// });
